<template>
  <PageBody>
    <div class="unauthorized-page">
      <p>You don't have permission to access this page.</p>
      <p>Please contact your administrator.</p>

      <router-link v-slot="{ navigate }" to="/profile" custom>
        <BaseButton @click="navigate">Go to Profile</BaseButton>
      </router-link>
    </div>
  </PageBody>
</template>

<script>
import BaseButton from "@/components-ng/BaseButton.vue";
import PageBody from "@/components-ng/PageBody.vue";

export default {
  name: "UnauthorizedPage",
  components: {
    BaseButton,
    PageBody,
  },
};
</script>

<style lang="scss" scoped>
@use "@/colors" as c;

.unauthorized-page {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  max-width: 600px;

  p {
    margin: 0;
    color: c.$text-subtle;
  }

  :deep(button) {
    margin-top: 16px;
  }
}
</style>
